export default __webpack_public_path__ + "6557ed66cfdef5a73219f1e36f387c43.png";